// extracted by mini-css-extract-plugin
export var Backdrop = "LocaleSwitcherModal-module--Backdrop--tm--S";
export var ContentArea = "LocaleSwitcherModal-module--ContentArea--vRbwp";
export var Message = "LocaleSwitcherModal-module--Message--XACmv";
export var Disclaimer = "LocaleSwitcherModal-module--Disclaimer--15mjT";
export var DismissButton = "LocaleSwitcherModal-module--DismissButton--2MLlW";